import Component from '../core/Component'
import { toggleClass, queryAll } from '../utils/dom'
import { scrollToElement } from '../services/Scroll'
import { submitForm } from '../nette/NetteAutosubmit'

const STATES = {
    READY: 'is-ready',
    HIDDEN: 'is-hidden'
}
export default class APCForm extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            brandElements: [],
            regionElements: [],
            regionSelect: null,
            brandSelect: null,
            submitButton: null,
            elements: [],
            providers: []
        }

        this.hasClicked = false
        this.request = null

        this._data = null
    }

    get data() {
        if (!this._data) {
            const data = Array.from(queryAll('input, select', this.element))
                .filter(element => {
                    if ((element.type === 'checkbox' || element.type === 'radio') && element.checked) {
                        return true
                    } else if (element.type !== 'checkbox' && element.type !== 'radio' && element.type !== 'submit') {
                        return true
                    }

                    return false
                })
                .reduce((acc, element) => {
                    const name = element.name
                    const value = element.value

                    if (name === 'services[]') {
                        acc[name] = acc[name] || []
                        acc[name].push(value)
                    } else {
                        acc[name] = value
                    }
                    return acc
                }, {})

            data.services = data['services[]']
            delete data['services[]']

            this._data = data
        }

        return this._data
    }

    prepare() {
        this.elements = this.ref.elements
            .map(element => ({
                element,
                rel: element.dataset.rel,
                inputs: queryAll('input[type="checkbox"], input[type="radio"]', element)
            }))

        this.element.addEventListener('change', this.handleChange)
        this.render()

        if (this.ref.submitButton) {
            this.ref.submitButton.addEventListener('click', this.handleSubmitClick)
        }

        this.element.classList.add(STATES.READY)

        this.selects = {}

        if (this.ref.regionSelect) {
            this.selects.regions = {
                element: this.ref.regionSelect,
                options: queryAll('option', this.ref.regionSelect)
                .map(element => ({
                    value: element.value,
                    label: element.textContent.trim()
                }))
            }
        }

        if (this.ref.brandSelect) {
            this.selects.brands = {
                element: this.ref.brandSelect,
                options: queryAll('option', this.ref.brandSelect)
                .map(element => ({
                    value: element.value,
                    label: element.textContent.trim()
                }))
            }
        }
    }

    handleChange = () => {
        this._data = null
        this.render()

        if (this.request) {
            this.request.abort()
        }

        this.request = $.ajax({
            url: this.element.action,
            method: this.element.getAttribute('method') || 'POST',
            data: this.data,
            success: this.handleCountChange
        })
    }

    handleCountChange = response => {
        let data = response
        if (!('regions' in data)) {
            data = {
                regions: data
            }
        }

        Object.keys(data)
            .filter(key => key in this.selects)
            .forEach(key => this.renderSelect(key, data[key]))
    }

    handleSubmitClick = event => {
        this.hasClicked = true

        if (event.isTrusted) {
            scrollToElement(document.getElementById('apc-list'))
        }
    }

    renderSelect(selectKey, data) {
        const { element, options } = this.selects[selectKey]

        const selectedIndex = element.selectedIndex

        element.innerHTML = options
            .map(item => {
                item.count = data[item.value] || 0
                return item
            })
            .map(item => `<option value="${item.value}" ${!item.count && item.value ? 'disabled' : ''}>${item.label} ${item.value ? `(${item.count})` : ''}</option>`)
            .join('\n')

        element.selectedIndex = selectedIndex
    }

    render() {
        const provider = this.ref.providers.filter(element => element.checked)[0]?.value

        this.elements.forEach(item => {
            const isHidden = item.rel.indexOf(provider) === -1

            if (isHidden) {
                item.element.classList.add(STATES.HIDDEN)
                item.inputs.forEach(input => input.checked = false)
            } else {
                item.element.classList.remove(STATES.HIDDEN)
            }
        })

        const { services, region, brand } = this.data

        const hasBrand = provider && services && (
            (provider === '1' && services.indexOf('2') > -1)
            || (provider === '2' && services.indexOf('3') > -1)
            || (provider === '3' && services.indexOf('4') > -1)
            || (provider === '4' && services.indexOf('2') > -1)
        )

        this.ref.brandElements.forEach(element => toggleClass(element, STATES.HIDDEN, !hasBrand))
        this.ref.regionElements.forEach(element => toggleClass(element, STATES.HIDDEN, !!hasBrand))

        if (this.ref.regionSelect) {
            this.ref.regionSelect.disabled = !provider
        }

        if (this.ref.brandSelect) {
            toggleClass(this.ref.brandSelect, STATES.HIDDEN, !hasBrand)
            if (!hasBrand) {
                this.ref.brandSelect.selectedIndex = 0
                this.ref.brandSelect.value = ''
                this._data = null
            }
        }


        if (this.ref.submitButton) {
            const brandValid = this.options.simple || ((hasBrand && brand) || !hasBrand)
            const regionValid = (this.ref.regionSelect && region) || !this.ref.regionSelect
            const valid = provider && services && services.length && regionValid && brandValid
            this.ref.submitButton.disabled = !valid

            if (valid && this.hasClicked) {
                this.ref.submitButton.click()
            }
        }
    }
}
